import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import nbrApi from "../../../services/nbrApi";
import { getFloorName } from "../../../services/common.utils";
import { useNavigate } from "react-router-dom";
import roomInspectorIcon from "../../../images/room_inspector.png";

const CartLocationManager = ({
    show,
    setShow,
    cartLoc, setCartLoc,
    floor, setFloor,
    room, setRoom,
    selectedLoginData,
    selectedData,
    cartIcon,
    ss_in,
    roleName,
    onComplete,
    startInSelection = false,
    status = "active"
}) => {
    const [cartLocation, setCartLocation] = useState(cartLoc || "");
    const [selectedFloor, setSelectedFloor] = useState(floor ?? "");
    const [selectedRoom, setSelectedRoom] = useState(room ?? "");
    const [floors, setFloors] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [floorsReady, setFloorsReady] = useState(false);
    const [roomsReady, setRoomsReady] = useState(!(floor ?? ""));
    const [selectionReady, setSelectionReady] = useState(false);
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        setCartLocation(cartLoc)
        setSelectedFloor(floor)
        setSelectedRoom(room)
    }, [cartLoc, floor, room])

    // Fetch floors
    useEffect(() => {
        if (selectedLoginData?.properties_id) {
            setFloorsReady(false);
            nbrApi.post('/getfloors', {
                    properties_id: selectedLoginData?.properties_id,
                })
                .then((res) => res.data)
                .then((data) => {
                    setFloors(data || []);
                    setFloorsReady(true);
                })
                .catch((error) => {
                    console.error("Error fetching floors:", error);
                    setFloorsReady(true);
                });
        }
    }, [selectedLoginData?.properties_id]);

    // Fetch rooms based on selected floor
    useEffect(() => {
        if (selectedFloor) {
            setRoomsReady(false);
            nbrApi.post('/getroomsbyfloor', {
                    properties_id: selectedLoginData?.properties_id,
                    floor: selectedFloor,
                })
                .then((res) => res.data)
                .then((data) => {
                    setRooms(data || []);
                    setRoomsReady(true);
                })
                .catch((error) => {
                    console.error("Error fetching rooms:", error);
                    setRoomsReady(true);
                });
        } else {
            setRooms([]);
            setRoomsReady(true);
        }
    }, [selectedFloor, selectedLoginData?.properties_id]);

    // Delay showing the selection form until dropdown options (and prepopulated values) are ready
    useEffect(() => {
        if (!show) {
            setSelectionReady(false);
            return;
        }
        if (!showLocationModal) return;
        if (!floorsReady) return;
        if (selectedFloor && !roomsReady) return;
        setSelectionReady(true);
    }, [show, showLocationModal, floorsReady, roomsReady, selectedFloor]);


    const handleUpdateCartLocation = () => {
        // API call to update the cart location
        nbrApi.post('/updatehkcartlocations', {
                properties_id: selectedLoginData?.properties_id,
                resources_id: selectedData?.resources_id,
                room_number: selectedRoom, // Send the selected room number in the payload
                status: status
            })
            .then((res) => res.data)
            .then((data) => {
                if (data) {
                    if (typeof onComplete === 'function') {
                        onComplete();
                    } else {
                        navigate('/tasks-process/' + ss_in)
                    }
                } else {
                    console.error('Failed to update cart location:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error updating cart location:', error);
            });
    };

    const handleOpenConfirm = () => {
        setShowLocationModal(false)
        setShowConfirmModal(true)
    }

    const handleOpenLocation = () => {
        setShowLocationModal(true)
        setShowConfirmModal(false)
    }

    useEffect(() => {
        if (show) {
            if (startInSelection) {
                setShowLocationModal(true)
                setShowConfirmModal(false)
            } else {
                setShowConfirmModal(true)
                setShowLocationModal(false)
            }
        } else {
            setShowConfirmModal(false)
            setShowLocationModal(false)
        }
    }, [show, startInSelection])

    const closeConfirm = () => {
        setShow(false)
        setShowConfirmModal(false)
    }

    const handleConfirm = () => {
        // When confirming from the confirmation modal, also update cart location with status
        nbrApi.post('/updatehkcartlocations', {
                properties_id: selectedLoginData?.properties_id,
                resources_id: selectedData?.resources_id,
                room_number: selectedRoom || room, // Use selected room or current room
                status: status
            })
            .then((res) => res.data)
            .then((data) => {
                if (data) {
                    if (typeof onComplete === 'function') {
                        onComplete();
                    } else {
                        navigate('/tasks-process/' + ss_in)
                    }
                } else {
                    console.error('Failed to update cart location:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error updating cart location:', error);
            });
    }

    // render
    return (
        <>
            {/* Backdrop (dark overlay) */}
            <div
                className={`modal-backdrop fade ${(showLocationModal || showConfirmModal) ? "show" : ""}`}
                style={{
                    display: (showLocationModal || showConfirmModal) ? "block" : "none",
                    zIndex: 1040,
                }}
            ></div>

            {/* Modal */}
            <div>
                {/* 1st Modal Content Start */}
                {/* <div className="d-flex align-items-center justify-content-center">
                    <img src={cartIcon} alt="Cart Icon" style={{ width: "30px" }} />
                    <p className="mb-0 ms-2 text-capitalize fw-bold">
                        {cartLocation || "8th Floor Storage Room"}
                    </p>
                </div>
                <button
                    className="btn btn-primary mt-3"
                    onClick={() => setShowConfirmModal(true)}
                >
                    Change Location
                </button> */}
                {/* 1st Modal Content End */}

                {/* 2nd Modal Content Start */}
                {/* Location Selection Modal */}
                {showLocationModal && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="locationModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="locationModalLabel">
                                        { startInSelection ? 'Where will you store your cart?' : roleName === 'room attendant' ? 'Select Your Cart Location' : 'Select Your Location'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={closeConfirm}
                                    ></button>
                                </div>
                                {!selectionReady ? (
                                    <div className="modal-body text-center py-5">
                                        <div className="spinner-border text-secondary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="modal-body">
                                            <div className="mb-3">
                                                <label htmlFor="floorDropdown" className="form-label">
                                                    Select Floor
                                                </label>
                                                <select
                                                    id="floorDropdown"
                                                    className="form-select"
                                                    value={selectedFloor === "" || selectedFloor == null ? "" : String(selectedFloor)}
                                                    onChange={(e) => setSelectedFloor(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select a floor</option>
                                                    {floors.map((floorOption) => (
                                                        <option key={floorOption.floor} value={String(floorOption.floor)}>
                                                            {floorOption.floor}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div>
                                                <label htmlFor="roomDropdown" className="form-label">
                                                    Select Room
                                                </label>
                                                <select
                                                    id="roomDropdown"
                                                    className="form-select"
                                                    value={selectedRoom === "" || selectedRoom == null ? "" : String(selectedRoom)}
                                                    onChange={(e) => setSelectedRoom(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select a room</option>
                                                    {rooms.map((roomOption) => (
                                                        <option key={roomOption.room_number} value={String(roomOption.room_number)}>
                                                            {roomOption.room_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="modal-footer justify-content-center border-0 gap-3 pt-0">
                                            <button
                                                type="button"
                                                className="circle-stop border-0 fs-7"
                                                onClick={handleOpenConfirm}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="circle-start border-0 fs-7"
                                                onClick={handleUpdateCartLocation}
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Confirmation Modal */}
                {showConfirmModal && (
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="confirmModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="confirmModalLabel">
                                        {roleName === 'room attendant' ? 'My Cart Location' : 'My Location'}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={closeConfirm}
                                    ></button>
                                </div>
                                <div className="modal-body mb-5">
                                    <div className="d-flex align-items-center justify-content-center">
                                        {roleName === "room inspector" ?
                                            <img src={roomInspectorIcon} alt="Cart Icon" style={{ width: 30 }} /> :
                                            <img src={cartIcon} alt="Cart Icon" style={{ width: 30 }} />}
                                        <strong className="text-black fs-3 font-medium">{cartLocation}</strong>
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-center border-0 gap-3 pt-0">
                                    <button
                                        type="button"
                                        className="circle-stop border-0 fs-7"
                                        onClick={handleOpenLocation}
                                    >
                                        Change
                                    </button>
                                    <button
                                        type="button"
                                        className="circle-start border-0 fs-7"
                                        onClick={handleConfirm}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* 2nd Modal Content End */}

            </div>
        </>
    );
};

export default CartLocationManager;
